import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';

@Component({
  selector: 'app-duplicate-datasource-dialog',
  templateUrl: './duplicate-datasource-dialog.component.html',
  styleUrls: ['./duplicate-datasource-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DuplicateDatasourceDialogComponent {

  datasourceName: string;
  infoList: string[] = [
    'همه ستون‌های اصلی کپی می‌شوند.',
    'همه ستون‌های افزوده‌شده در منبع داده کپی می‌شوند.',
    'ارتباطات، فیلتر کاربری و زمانبندی کپی نمی‌شوند.',
  ];

  isInfoExpanded = false;
  constructor(private dialogRef: NbDialogRef<any>) {}
  
  toggleInfo() {
    this.isInfoExpanded = !this.isInfoExpanded;
  }

  onSubmitClick() {
    this.dialogRef.close(true);
  }

  closeDialog() {
    this.dialogRef.close(false);
  }
}
